// extracted by mini-css-extract-plugin
export var columnItems = "previewColumn-module--column-items--67TIV";
export var linkArrow = "previewColumn-module--link-arrow--6JPEd";
export var previewColumn = "previewColumn-module--preview-column--JPGZv";